import React from 'react'
import { AlertCircle, CheckCircle } from 'lucide-react'

/** Inline status message for the device approval pages. */
export const Message: React.FC<{ tone: 'error' | 'warn' | 'ok'; children: React.ReactNode }> = ({ tone, children }) => {
  const styles = {
    error: 'bg-red-50 border-red-200 text-red-800',
    warn: 'bg-amber-50 border-amber-200 text-amber-900',
    ok: 'bg-green-50 border-green-200 text-green-800',
  }[tone]
  const Icon = tone === 'ok' ? CheckCircle : AlertCircle
  return (
    <div role={tone === 'error' ? 'alert' : 'status'} className={`flex items-start gap-2 border rounded-xl p-3 mb-4 ${styles}`}>
      <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <div>{children}</div>
    </div>
  )
}

export default Message
